/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from '../../components/Code';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "根据属性进行调整(Adapting based on props)"
    }), "\n", _jsx(_components.p, {
      children: "¥Adapting based on props"
    }), "\n", _jsx(_components.p, {
      children: "你可以将函数 (\"interpolations\") 传递给样式化组件的模板字面量，以根据其 props 进行调整。"
    }), "\n", _jsx(_components.p, {
      children: "¥You can pass a function (\"interpolations\") to a styled component's template literal to adapt it based on its props."
    }), "\n", _jsxs(_components.p, {
      children: ["该按钮组件有一个改变其颜色的主要状态。当将 ", _jsx(Code, {
        children: "$primary"
      }), " 属性设置为 true 时，我们将交换其背景和文本颜色。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This button component has a primary state that changes its color. When setting the ", _jsx(Code, {
        children: "$primary"
      }), " prop to true, we are swapping out its background and text color."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Button = styled.button<{ $primary?: boolean; }>`\n  /* Adapt the colors based on primary prop */\n  background: ${props => props.$primary ? \"#BF4F74\" : \"white\"};\n  color: ${props => props.$primary ? \"white\" : \"#BF4F74\"};\n\n  font-size: 1em;\n  margin: 1em;\n  padding: 0.25em 1em;\n  border: 2px solid #BF4F74;\n  border-radius: 3px;\n`;\n\nrender(\n  <div>\n    <Button>Normal</Button>\n    <Button $primary>Primary</Button>\n  </div>\n);\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
